function SalesDashboard() {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold mb-4">Sales Dashboard</h1>
        RevenueDashboard
      </div>
    );
  }
  
  export default SalesDashboard;